import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";

class Brand extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: '',
			selectedBrands: (props.selectedBrands === null) ? [] : props.selectedBrands.split(', ')
		};

		this.selectAll = this.selectAll.bind(this);
		this.unselectAll = this.unselectAll.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({selectedBrands: (nextProps.selectedBrands === null) ? [] : nextProps.selectedBrands.split(', ')});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getData()
		i18next.on('languageChanged', (lng) => {this.getData()})
	}

	render() {
		var brands = this.state.data.data || [];
		return(
			<div className="container main">
				<Progress t={this.props.t} goTo={this.props.goTo} step={1} traject={this.props.traject} />
				<form className="brands" onSubmit={this.handleSubmit}>

					<div className="row">
						<div className="col-12 text-center title">
							<h2>{this.props.t('Welke merken hebben jouw voorkeur?')}</h2>
						</div>
					</div>

					{ brands.length === 0 &&
						<div>{this.props.t('Geen merken gevonden die voldoen aan uw selectie')}</div>
					}
					{ brands.length > 0 &&
						<div className="row checkboxes justify-content-center">
							<div className="col-lg-6 mb-4">
								<div className="buttons">
									<button className="btn btn-primary" onClick={this.selectAll}>{this.props.t('brands select all')}</button>
									&nbsp;
									<button className="btn btn-default" onClick={this.unselectAll}>{this.props.t('brands unselect all')}</button>
								</div>
							</div>
							<div className="w-100"></div>
							<div className="col-lg-6">
								<div className="row">
									{brands.map((brand, i) => {
										return (
											<div className="col-6 brand" key={i}>
												<label>
													<input value={brand} type="checkbox"
														   onChange={this.handleChange}
														   checked={this.state.selectedBrands.indexOf(brand) !== -1}/>
														   &nbsp;{brand}
												</label>
											</div>
										)
									})}
								</div>
							</div>
						</div>
					}

					<div className="row mt-5">
						<div className="col-6 text-left">
							<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
						</div>
						<div className="col-6 text-right">
							<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
						</div>
					</div>
				</form>

			</div>
		);

	}

	getData () {
		Api.get('/brand', {bike_type: this.props.bikeType}).then(response => {
			this.setState({data: response.data})
		})
	}

	selectAll(event) {
		event.preventDefault();
		let allBrands = this.state.data.data.slice(0); // by value
		this.setState({selectedBrands: allBrands});
	}

	unselectAll(event) {
		event.preventDefault();
		this.setState({selectedBrands: []});
	}

	handleChange(event) {
		let value = event.target.value;
		let selectedBrands = this.state.selectedBrands.slice(0); // by value
		let index = selectedBrands.indexOf(value);
		if (index === -1){
			selectedBrands.push(value);
			this.setState({"selectedBrands": selectedBrands});
		} else {
			selectedBrands.splice(index, 1);
			this.setState({"selectedBrands": selectedBrands});
		}
	}

	handleSubmit(event) {
		event.preventDefault();

		this.props.handler(this.state.selectedBrands).then(() => {
			if (this.state.selectedBrands.length === 0) {
				alert(this.props.t('please provide an answer'));
			} else {
				this.props.goTo('/advice/gender', this.props.traject);
			}
		});
	}

	goBack(e) {
		e.preventDefault();
		this.props.goTo('/advice/image', this.props.traject);
	}
}

export default withTranslation('brand')(Brand);
